import React from 'react';
import { motion } from 'motion/react';
import { EASE_IN_OUT } from '../../lib/motion';
import Label from '../primitives/Label';
import { company } from '../../data/site';

/*
 * The landing page's loading screen, shown once per session while three.js loads and the
 * formations and simulation are built: it says what's coming, counts up, then lifts away on
 * its own. No choice to make; sound stays off until the visitor turns it on (bottom right).
 */
const LabGate = ({ phase, loaded }) => {
  const percent = Math.round(loaded * 100);
  const ready = phase === 'gate';

  return (
    <motion.div
      className="absolute inset-0 z-30 flex flex-col items-center justify-center gap-10 bg-background/75 px-[var(--gutter)] text-center backdrop-blur-[2px]"
      exit={{ opacity: 0, transition: { duration: 1.1, ease: EASE_IN_OUT } }}
    >
      <Label dot>{company.name}</Label>
      <div className="max-w-3xl">
        <p className="text-balance text-[clamp(2.5rem,6vw,5.25rem)] font-[430] leading-[0.98] tracking-[-0.04em] [font-stretch:112%]">
          An <span className="accent">immersive</span> experience
        </p>
        <p className="mx-auto mt-6 max-w-xl text-balance text-[1rem] leading-relaxed text-muted-foreground md:text-[1.0625rem]">
          Explore our services as interactive 3D worlds. Scroll to travel, move the pointer through the field, and turn the sound on any time at the bottom right.
        </p>
      </div>

      <div className="w-[min(22rem,80vw)]" role="status" aria-live="polite">
        <div className="flex items-baseline justify-between font-mono text-[0.6875rem] uppercase tracking-[0.12em] text-muted-foreground">
          <span>{ready ? 'Ready' : 'Loading the experience'}</span>
          <span className="text-foreground">{String(percent).padStart(3, '0')}</span>
        </div>
        <div className="mt-3 h-px w-full bg-foreground/10">
          <div className="h-px origin-left bg-gradient-to-r from-brand to-brand-2 transition-transform duration-300 ease-out" style={{ transform: `scaleX(${loaded})` }} />
        </div>
      </div>
    </motion.div>
  );
};

export default LabGate;
